import { Button, List } from 'antd';
import * as _ from 'lodash';
import * as React from 'react';
import { DeleteOutlined } from '@ant-design/icons';

import AttributeValueDetail from './components/AttributeValueDetail';
import AttributeValueView from './components/AttributeValueShow';
import { FormItem } from '../../../../../components/Form';

export interface IValuesProps {
  attribute: GQL.IAttribute;
  currentLanguage: string;
  languages: Array<GQL.ILanguage>;
  onChange: Function;
}

export interface IValuesState {
  valueIndex?: any;
}

export default class Values extends React.Component<IValuesProps, IValuesState> {

  public constructor(props: IValuesProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  public render() {
    const { attribute, languages } = this.props;

    return (
      <div>
        <FormItem label={'Values'}>
          <List
            size={'small'}
            bordered={true}
            dataSource={attribute.values || []}
            renderItem={(item: GQL.IAttributeValue, index: number) => {
              return (
                <List.Item
                  actions={[
                    <Button
                      danger={true}
                      key={1}
                      size={'small'}
                      icon={<DeleteOutlined />}
                      onClick={() => {
                        let values = [...attribute.values || []];
                        values.splice(index, 1);
                        this.onChange('values', values);
                      }}
                    />
                  ]}
                  key={index}
                  style={{ paddingRight: '8px' }}
                >
                  <AttributeValueView
                    attribute={attribute as GQL.IAttribute}
                    value={item}
                    onClick={() => this.setState({ valueIndex: index }) }
                  />
                </List.Item>
              );
            }}
          />
          <Button onClick={() => this.setState({ valueIndex: -1 })} style={{ float: 'right', marginTop: 10 }}>New Value</Button>
        </FormItem>

        {this.state &&
          this.state.valueIndex != undefined && (
            <AttributeValueDetail
              languages={languages}
              value={this.getValueForDetail()}
              attribute={attribute}
              onSave={value => this.onSaveValue(value)}
              onCancel={() => this.setState({ valueIndex: undefined })}
            />
          )}
      </div>
    );
  }

  /**
   * Data hodnoty do formuláře
   */
  private getValueForDetail() {
      const { valueIndex } = this.state;
      if (valueIndex >= 0) {
          return (this.props.attribute.values || [])[valueIndex];
      }

      return {
          title: ''
      } as GQL.IAttributeValue;
  }

  /**
   * Uložení hodnoty atributu
   * 
   * @param newValue
   */
  private onSaveValue(newValue: GQL.IAttributeValue) {
      const { values } = this.props.attribute;
      let newValues = values != undefined ? [...values] : [];

      if (this.state.valueIndex >= 0) {
          newValues[this.state.valueIndex] = newValue;
      } else {
          newValues.push(newValue);
      }

      this.onChange('values', newValues);
      this.setState({ valueIndex: undefined });
  }

  private onChange(key: string, val: any) {
    this.props.onChange({
      target: {
        name: key,
        value: val
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Attributes/AttributeDetail/components/Values/Values.tsx